document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                }
            });
            let linkSwiper = document.querySelectorAll(".swiper-pagination-bullet");
            linkSwiper.forEach((nav)=>{
                nav.addEventListener("mouseover",()=>{
                    nav.click();
                });
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slide-slider');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "fade",
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let carouselSlider = document.querySelectorAll('.carousel-slider');
    if(carouselSlider){
        carouselSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 2,
                    }
                }
            });
        });
    }

    let carouselVSlider = document.querySelectorAll('.carousel-v-slider');
    if(carouselVSlider){
        carouselVSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 50,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 2,
                    }
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                    }
                }
            });
        });
    }

});